import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './EditLotShipmentModalComponent.css';
import edit_lot_base_image from '../../../src/assets/images/edit_lot_base_image.png';
import edit_lot from '../../../src/assets/images/edit_lot.png';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateShipmentProductLotQty, addShipmentProductLots, fetchStockById } from '../../redux/shipmentSlice'
import {toast} from 'react-hot-toast';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

const EditLotShipmentModalComponent = ({ isOpen, onClose, shipmentId, stock, shipmentProductId, shipmentProductLotId, updateLotCount }) => {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  // console.log("stock",stock)
  // console.log("shipmentProductId",shipmentProductId);
  const [consumeProductQty, setConsumeProductQty] = useState('');
  const [errors, setErrors] = useState('');

  const handleTextChange = (event) => {
    const { value } = event.target;
    const enteredQty = parseInt(value);
    const maxQty = stock?.productQty || 0;
    if (!value.trim()) {
      setErrors('Quantity is required');
    } else if (enteredQty < 1 || enteredQty > maxQty) {
      setErrors(`Invalid Quantity`);
    } else {
      setErrors('');
      setConsumeProductQty(enteredQty);
    }
  };
  // const stockDetails = useSelector((state) => state.shipment.stockDetails || []);

  //  const handleTextChange = (e) => {
  //   setConsumeProductQty(e.target.value);
  //  };

  //  useEffect(() => {
  //   dispatch(fetchStockById(stock.stockLotId));
  //   console.log("stockDetails",stockDetails);
  //  })

  const handleSubmit = () => {
    if (consumeProductQty) {
      //  console.log('Text submitted:', consumeProductQty,"shipmentProductLotId",shipmentProductLotId);
      //  console.log('stock.stockLotId:', stock.stockLotId,"shipmentProductId",shipmentProductId,"consumeProductQty",consumeProductQty);
      if (shipmentProductLotId) {
        dispatch(updateShipmentProductLotQty({ shipmentProductLotId, consumeProductQty }))
        .then(() => {
          updateLotCount()
        })
        .catch((error) => {
          toast.error("Error occurred:",error)
        });
      } else {
        dispatch(addShipmentProductLots({ shipmentProductId, stockLotId: stock.stockLotId, consumeProductQty }))
        .then(() => {
          updateLotCount();
        })
        .catch((error) => {
          toast.error("Error occurred:",error)
        })
      }
      onClose(false);
    }
  };

  const handleClickOpen = () => {
    // setOpen(true);
  };
  const handleClose = () => {
    // setOpen(false);
    onClose(false);
  };

  return (
    <React.Fragment >
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Edit Lot Shipment Modal
      </Button> */}
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        className='editLotshipmentDeclineModalBody'

      >
        <DialogTitle sx={{ m: 0, p: "0px 39px " }} id="customized-dialog-title">
          {/* Modal title */}
          <div className='editLotmodalImagediv'>
            <img
              className='modalImage1'
              src={edit_lot_base_image}
            />
            <img
              className='modalImage2'
              src={edit_lot}
            />
            <h4 className='headingForEditLotShipmentModal'> Lot Edit </h4>
          </div>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            backgroundColor: "white",
            height: "7%",
            width: "6%",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
            <h4 className='titleHeadingForEditLotModal'>Available Quantity {stock?.productQty}</h4>
            <h4 className='titleHeadingForEditLotModal1'>To be consumed</h4>
            <div className='shipmentEditLotModalTextField'>
              <TextField
                label="Quantity"
                variant="outlined"
                fullWidth
                inputProps={{
                  style: {
                    height: "20px",
                  },
                }}
                value={consumeProductQty}
                onChange={handleTextChange}
                margin="normal"
                type="number"
                required
                error={!!errors}
                helperText={errors}
              />
            </div>
          </Typography>

        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleSubmit} variant="contained" color="primary"
            style={{ width: "400px", marginRight: "19%", marginLeft: "20%", backgroundColor: "rgb(4 176 54)", textDecoration: "white" }}
          >
            Update
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}

export default EditLotShipmentModalComponent;
